import { Module } from "vuex";
import * as firebase from 'firebase/app';
import 'firebase/firestore';
import { serializer } from "@/api/shared/serializer";
import { getWhereIdInIds } from "@/utils/getWhereIdInIds";
import { UserTypeEnum } from "@/enums/UserTypeEnum";
import { AuditLogsTier1 as Tier1, AuditLogsTier2 as Tier2, AuditLogsTier3 as Tier3 } from '@/enums/AuditLogs';

const tagsModule: Module<any, any> = {
  namespaced: false,
  state: {
    tags: []
  },

  mutations: {
    setTags(state: any, payload: []) {
      state.tags = payload;
    }
  },

  actions: {
    async getTags({ commit }) {
      const snap = await firebase.firestore().collection("tags").where('facilityId', '==', this.state.authModule.currentFacility).get()
      const tags = serializer.querySnapshotToDocuments<any>(snap)
      commit("setTags", tags);
    },

    async addTags({ dispatch }, data) {

      if (!data.tagsNames || !data.entity) return

      try {
        const existedTags = await getWhereIdInIds('name', data.tagsNames, 'tags', this.state.authModule.currentFacility) || []

        if (existedTags?.length > 0) return {
          isSuccess: false,
          existedTags: existedTags.map(x => x.name)
        }

        const today = firebase.firestore.Timestamp.fromDate(new Date())

        const tagsObjects = data.tagsNames.map(name => {
          return {
            name: name.trim().toLowerCase(),
            facilityId: this.state.authModule.currentFacility,
            createdDateTime: today,
            createdForEntity: data.entity,
            createdById: this.state.authModule.user.id,
            createdByType: UserTypeEnum.Staff,
            typesOfRecordChanged: [`${Tier1.StaffHubSettings}: ${Tier2.StaffSettings}: ${Tier3.ResidentTags}`]
          }
        })

        console.log('tagsObjects', tagsObjects)

        const addedTagsRefs = await Promise.all(tagsObjects.map(tagObj => {
          return firebase.firestore().collection("tags").add(tagObj);
        }));

        await dispatch("getTags")

        const addedTagIds = addedTagsRefs.map((tagRef: any) => tagRef.id);

        return {
          isSuccess: true,
          addedTagIds: addedTagIds
        }

      } catch (error) {
        return {
          isSuccess: false
        }
      }

    },

    async updateTag({ dispatch }, data) {

      if (!data.id || !data.name) return

      const query = await firebase.firestore().collection("tags")
        .where("facilityId", "==", this.state.authModule.currentFacility)
        .where("name", "==", data.name.trim().toLowerCase())
        .where(firebase.firestore.FieldPath.documentId(), '!=', data.id).get()

      if (query.size > 0) {
        return {
          isExistByName: true
        }
      }

      return await firebase.firestore().collection("tags").doc(data.id).update({
        name: data.name,
        dateTimeUpdated: firebase.firestore.Timestamp.fromDate(new Date()),
        updatedById: this.state.authModule.user.id,
        updatedByType: UserTypeEnum.Staff,
        typesOfRecordChanged: [`${Tier1.StaffHubSettings}: ${Tier2.StaffSettings}: ${Tier3.ResidentTags}`]
      })
        .then(async () => {
          await dispatch("getTags")
          return { isSuccess: true }
        })
        .catch(() => {
          return { isSuccess: false }
        })
    },

    async deleteTag({ dispatch }, id) {
      if (id?.length <= 0) return;
    
      const db = firebase.firestore();
    
      try {
        await db.runTransaction(async (transaction) => {
          const tagDocRef = db.collection("tags").doc(id);
          const tagSnapshot = await transaction.get(tagDocRef);
    
          if (!tagSnapshot.exists) return;
    
          const records = await dispatch("isTagInUse", id);
          const updatePromises = [];
    
          for (const r of records) {
            const recordDocRef = db.collection(r.collection).doc(id);
            const recordSnapshot = await transaction.get(recordDocRef);
    
            if (r.collection === "residents" && recordSnapshot.exists) {
              const updateData = {
                interestsTags: recordSnapshot.data().interestsTags.filter(x => x !== id),
                preferencesTags: recordSnapshot.data().preferencesTags.filter(x => x !== id),
                backgroundTags: recordSnapshot.data().backgroundTags.filter(x => x !== id)
              };
    
              updatePromises.push(transaction.update(recordDocRef, updateData));
            }
          }
    
          // Delete the tag
          transaction.delete(tagDocRef);
    
          // Wait for all updates to complete
          await Promise.all(updatePromises);
        });
        await dispatch("getTags")
      } catch (error) {
        console.error("Error deleting tag and updating records:", error);
      }
    },
    
    async isTagInUse({ dispatch }, tagId) {
      const residentsShortData = this.state.residentModule.residentsShortData;

      const records = residentsShortData.filter(r => {
        const interestsTags = r.interestsTags || [];
        const preferencesTags = r.preferencesTags || [];
        const backgroundTags = r.backgroundTags || [];
        r.collection = 'residents'
        return interestsTags.some(t => t === tagId) || preferencesTags.some(t => t === tagId) || backgroundTags.some(t => t === tagId)
      });

      return records
    }
  }
};
export default tagsModule;